import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';
import SearchBar from '../../searchBar/searchBar';



function CriarPortaria() {
  const navigate = useNavigate();

  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/portaria')

  const [formValue, setFormValue] = useState({
    nomePorteiro:'',
    idFilial: userLogin.idfilial,
    nomeFilial: userLogin.nomefilial,
    idEscola: userLogin.idescola,
    nomeEscola: userLogin.nomeescola,
    login: '',
    senha: ''
  });

  const handleSubmit = async (values) => {

    values.preventDefault();
    util.isSubmitting()
    const result = await api.registrarPortariaApi(formValue);
    result ? toast.success("Criado com sucesso!") && navigate("/area-portaria") : null;
    util.isSubmitting()
    
  }


  

  
  
  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      height:"100vh", minHeight:'500px',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-75' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                    <MDBValidationItem style={{width:'100%'}} feedback='Por favor digite o nome do porteiro!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='Nome do porteiro' id='formControNomePorteiro' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomePorteiro'
                          value={formValue.nomePorteiro || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'100%'}} feedback='Por favor digite seu login!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='Login' 
                          name='login'
                          id='formControLogin' 
                          type='text' 
                          size="lg"
                          value={formValue.login || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          style={{color:"white"}}/>
                      </MDBValidationItem >
                    
                   
                      <MDBValidationItem style={{width:'100%'}} feedback='Por favor digite sua senha!' invalid>
                        <MDBInput 
                          wrapperClass='w-100' 
                          className='mb-5'
                          labelClass='text-white' 
                          label='Senha' 
                          name='senha'
                          id='formControSenha' 
                          type='password' 
                          size="lg"
                          value={formValue.senha || ''}
                          onChange={onChange}
                          required
                          style={{color:"white"}}/>
                          
                        
                     
                      </MDBValidationItem >
                      
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='submit'   
                        id='submitForm'  
                        //disabled={formValue.senha.length < 3 || formValue.nomeAdministrador.length < 1 || formValue.login.length < 1}                 
                        >
                        
                        Registrar
                      </MDBBtn>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/area-portaria")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarPortaria;